export const FAQS = [
  {
    category: "General",
    question: "What is DINEVIQ and how does it work?",
    answer: "DINEVIQ is an autonomous AI-powered restaurant operating system. It synchronizes digital QR table menus, real-time Kitchen Display Systems (KDS), cloud POS billing, recipe-level inventory, and real-time revenue analytics into one unified console."
  },
  {
    category: "QR Ordering",
    question: "Do guests need to download an application to order?",
    answer: "No. Guests simply point their phone camera at the table QR code. DINEVIQ opens instantly in their native mobile browser with a high-resolution visual menu in Indian Rupees (₹), offering one-tap UPI payments."
  },
  {
    category: "Kitchen (KDS)",
    question: "How fast do tickets appear in the kitchen?",
    answer: "Under 50 milliseconds. The moment a diner or server taps 'Place Order', WebSocket channels instantly dispatch the order directly to the designated station screens (Grill, Bar, Fryer, Bakery, Expo)."
  },
  {
    category: "Payments",
    question: "Which payment gateways and UPI methods are supported?",
    answer: "DINEVIQ integrates natively with all major Indian UPI rails (Google Pay, PhonePe, Paytm, BHIM, CRED), NetBanking, and credit/debit cards with instant settlement capabilities."
  },
  {
    category: "Hardware",
    question: "What hardware is required to run DINEVIQ?",
    answer: "Zero hardware lock-in. DINEVIQ runs in any modern browser on Android tablets, iPads, touch POS terminals, smart TVs, PCs, and thermal receipt printers."
  },
  {
    category: "Pricing & Trial",
    question: "Can I try DINEVIQ before committing?",
    answer: "Yes! We offer a full-featured 14-day free trial with complimentary menu digitization and on-call specialist onboarding."
  }
];
